import React from "react"
import { Grid } from "@mui/material"

import {UserSettingsAcrissTable, UserSettingAcrissDrawer} from "./Acriss"
import {UserSettingCategoryDrawer, UserSettingsCategoryTable} from "./Category"


export default function UserSettingsItemsTab() {
    return <Grid container spacing={1}>
		<Grid item xs={6}>
			<UserSettingsAcrissTable />
		</Grid>

		<Grid item xs={6}>
			<UserSettingsCategoryTable />
		</Grid>

		<UserSettingAcrissDrawer />
		<UserSettingCategoryDrawer />
    </Grid>
}